// extracted by mini-css-extract-plugin
module.exports = {"row":"Header_row__1B72g","score":"Header_score__2iyRV"};